import { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import WarehouseSubNav, { WarehouseSubTab } from './WarehouseSubNav';
import WarehouseListView, { WarehouseListViewRef } from './WarehouseListView';
import ProductsListView, { ProductsListViewRef } from './ProductsListView';

const WarehouseTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<WarehouseSubTab>('warehouse');
  const warehouseViewRef = useRef<WarehouseListViewRef>(null);
  const productsViewRef = useRef<ProductsListViewRef>(null);

  const handleCreate = () => {
    if (activeSubTab === 'warehouse') {
      warehouseViewRef.current?.createNew();
    } else {
      productsViewRef.current?.createNew();
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between min-h-10">
          <h2 className="text-2xl font-bold">Almacén</h2>

          <Button
            onClick={handleCreate}
            className="bg-brand-primary hover:bg-brand-primary-hover flex items-center gap-2"
          >
            <Plus size={16} />
            {activeSubTab === 'warehouse' ? 'Agregar al Almacén' : 'Nuevo Producto'}
          </Button>
        </div>

        <WarehouseSubNav
          activeSubTab={activeSubTab}
          onSubTabChange={setActiveSubTab}
        />
      </div>

      {activeSubTab === 'warehouse' ? (
        <WarehouseListView ref={warehouseViewRef} />
      ) : (
        <ProductsListView ref={productsViewRef} />
      )}
    </div>
  );
};

export default WarehouseTab;
